<template>
  <div class="m_container">
    <Header :title="title" />
    <section class="m_section">
      <div class="list">
        <div class="theader">
          <p class="lis">姓名</p>
          <p class="lis">科目</p>
          <p class="lis">考级</p>
          <p class="lis">状态</p>
          <p class="lis opera">操作</p>
        </div>
        <div v-for="(item,index) in list" :key="index" class="theader tbody">
          <p class="lis">{{ item.name }}</p>
          <p class="lis">{{ item.subject }}</p>
          <p class="lis">{{ item.level }}</p>
          <p class="lis">{{ item.status_name }}</p>
          <div class="lis opera opera_center">
            <p v-if="!item.ticket" class="edit" @click="navigateToConfirm(item)">打印</p>
          </div>
        </div>
      </div>
    </section>
    <TabBar :current-tab="currentTab" />
  </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { getSid, setSid } from '@/utils/cookies'
import { mapGetters } from 'vuex'
import { admissionList } from '@/api/SignupSubject'

export default {
  name: 'AdmissionTicket',
  components: { Header, TabBar },
  data() {
    return {
      sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
      currentTab: 'admissionTicket',
      title: '我的准考证',
      listQuery: {
        sid: this.$route.query.sid ? this.$route.query.sid : getSid()
      },
      list: [],
      loading: false,
      showLogout: !!this.$store.getters.token
    }
  },
  computed: {
    ...mapGetters(['examInfo'])
  },
  created() {
    this.sid ? setSid(this.sid) : ''
    this.$store.getters.token ? this.getList() : this.toLogin()
  },
  methods: {
    toLogin() {
      this.$alert('请先登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          this.$router.push({ path: '/login', query: { sid: this.sid }})
        }
      })
    },

    getList() {
      this.loading = true
      admissionList(this.listQuery).then(res => {
        if (res.code === 200) {
          this.list = res.data
          this.loading = false
        }
      }).catch(() => { this.loading = false })
    },

    navigateToConfirm(item) {
      this.$router.push({ path: '/confirmExam', query: { sid: this.sid, issubmit: '3', id: item.id }})
    }

  }
}
</script>

<style lang="less" scoped>
.noscroll{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f5f5;

  .m_section {
    flex:1;
    padding-bottom: 100px;

    .list{
      color: #999;
      line-height: 38px;
      padding: 0;
      font-size: 13px;
      background: #fff;
      margin: 10px 10px;
    }

    .theader{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #f6f6f6;

      .lis{
        flex:2;
        padding: 0 6px;
        text-align: center;
        font-size: 14px;
        color: var(--bck);
        font-weight: bold;
        // overflow: hidden;
        // white-space: nowrap;
        // text-overflow: ellipsis;
      }

      .lis:nth-last-child(2){
        flex: 1.1;
      }

      .opera{
        flex:1.5;
        padding: 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        .confirm_gray{
          color: #999;
        }
      }
    }

    .tbody{
      .lis{
        color: #999;
        font-size: 8px;
        font-weight: normal;
        line-height: 38px;
      }
      .opera{
        color: var(--color);
        justify-content: space-between;
      }

      .opera_center{
        justify-content:center;
      }
    }

    .submitBtn{
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 80px;
      width: 90%;
    }
  }
}
</style>
